module.exports = __webpack_public_path__ + "img/blocks.76b41827.png";